import { productSingleActions } from '../config/actions';

const defaultState = {
  isLoading: null,
  data: [],
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case productSingleActions.PRODUCT_SINGLE_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        error: null
      };
    case productSingleActions.PRODUCT_SINGLE_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        error: action.error,
        evidence: null,
        history: state.history || []
      };
    case productSingleActions.PRODUCT_SINGLE:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    case productSingleActions.PRODUCTS_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        error: null
      };
    default:
      return state;
  }
};
